<template>
  <div class="asc-logout-dailog">
    <asc-dialog
      :show-dialog="showDialog"
      text="Log Out"
      :on-primary="handleAccept"
      :on-secondary="handleReject"
      :on-close="handleReject"
      secondary-button-text="no"
      primary-button-text="yes"
    >
      Are you sure you want to log out of Ascentia?
    </asc-dialog>
  </div>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'

export default {
  name: 'AscLogoutDialog',

  components: {
    AscDialog,
  },

  mixins: [AscDialogMixin],

  methods: {
    async handleAccept() {
      await this.onAccept()
      this.handleClose()
    },
    handleReject() {
      this.handleClose()
    },
  },
}
</script>
<style lang="scss">
.asc-logout-dailog {
  .asc-dialog {
    .v-card__text {
      min-height: auto !important;
      padding: 16px 16px 19px !important;
    }
  }
}
</style>
